/**
 * Track order form: opens the entered tracking number on 17TRACK in a new tab.
 */
class TrackOrderForm extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('[data-form]');
    const input = /** @type {HTMLInputElement | null} */ (this.querySelector('[data-input]'));
    if (!form || !input) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const number = input.value.replace(/\s+/g, '').toUpperCase();
      if (!number) return;
      window.open(`https://t.17track.net/en#nums=${encodeURIComponent(number)}`, '_blank', 'noopener');
    });
  }
}

if (!customElements.get('track-order-form')) {
  customElements.define('track-order-form', TrackOrderForm);
}
